import { render, staticRenderFns } from "./DccChoice.vue?vue&type=template&id=0540b3b7&"
import script from "./DccChoice.vue?vue&type=script&lang=ts&"
export * from "./DccChoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports